import {JsonObject, JsonProperty} from 'json2typescript';
import {Message} from '../microsite/message';
import {MessageConverter} from '../../customJsonConverters/MessageConverter';
import {TSStringToStringMapConverter} from '../../customJsonConverters/TSStringToStringMapConverter';
import {TSMap} from 'typescript-map';


@JsonObject('TextMessage')
export class TextMessage {

    @JsonProperty('order_id',Number,true)
    order_id = 0;

    @JsonProperty('class_id',String,true)
    class_id = '';

    // Only for microsite
    @JsonProperty('message',MessageConverter,true)
    message:Message = new Message();

    @JsonProperty('clearText',Boolean,true)
    clearText = false;

    @JsonProperty('uid',String,true)
    uid = '';

   @JsonProperty('fontSize',Number,true)
  fontSize = 0;

  @JsonProperty('fontFamily',String,true)
  fontFamily = '';

  @JsonProperty('fontColor',String,true)
  fontColor = '#000000';

  @JsonProperty('fontWeight',String,true)
  fontWeight = '';

  // for email only
  @JsonProperty('texts',TSStringToStringMapConverter,true)
  texts:TSMap<string,string> = new TSMap();

  constructor() {

  }


}
